/* eslint-disable */

/* global instantsearch algoliasearch */
const searchClient = algoliasearch(
  'X3GSQRCLVS',
  'b72b71a074b9729c1b7f6fbd6fc6ab9f'
);


const search = instantsearch({
  indexName: 'website',
  searchClient,
  numberLocale: 'nl',
  insights: true,
  routing: {
    stateMapping: {
      stateToRoute: function (uiState) {
        return {
          q: uiState['website'].query,
        };
      },
      routeToState: function (routeState) {
        return {
          website: {
            query: routeState.q,
          },
        };
      },
    },
  },
});


search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox',
    placeholder: 'Waar ben je naar op zoek?',
    showReset: false,
    showSubmit: false,
    cssClasses: {
      input: 'form__input p-6'
    },
    templates: {
      loadingIndicator({cssClasses}, {html}) {
        return html`<span class="${cssClasses.loadingIndicator}">loading</span>`;
      },
    },
  }),

  instantsearch.widgets.stats({
    container: '#stats',
    templates: {
      text(data, { html }) {
        let count = '';

        if (data.hasManyResults) {
          count += `${data.nbHits} resultaten`;
        } else if (data.hasOneResult) {
          count += `1 resultaat`;
        } else {
          count += `geen resultaten`;
        }

        return html`<span>${count} gevonden in ${data.processingTimeMS}ms</span>`;
      },
    },
  }),


  instantsearch.widgets.refinementList({
    container: '#interests',
    attribute: 'interests',
    searchablePlaceholder: 'Search our products',
    limit: 15,
    sortBy: ['name:asc'],
    cssClasses: {
      item: '',
    },

  }),


  instantsearch.widgets.infiniteHits({
    container: '#results',
    cssClasses: {
      item: 'border-b border-ao-beige-darken py-3',
      loadMore: 'c-btn c-btn--primary text-center',
      disabledLoadMore: 'hidden'
    },

    templates: {

      item: `
        <article>
           <h5 class="text-md md:text-lg mb-1">
           <a href="{{url}}">{{#helpers.highlight}}{ "attribute": "title", "highlightedTagName": "mark" }{{/helpers.highlight}}</a></h5>
            <p class="mb-0 text-md">{{#helpers.highlight}}{ "attribute": "subtitle", "highlightedTagName": "mark" }{{/helpers.highlight}}</p>
          <p class="mb-0 text-md">{{#helpers.snippet}}{ "attribute": "bodyBuilder", "highlightedTagName": "mark" }{{/helpers.snippet}}</p>
        
        </article>
      `,

      empty(results, {html}) {
        return html`<p>Geen resultaten gevonden voor <q>${results.query}</q></p>`;
      },

      showMoreText: ({isShowingMore}, {html}) => {
        return html`Laad meer`;
      },

    },
  })

]);


search.start();
